import React, { FC } from 'react';

// Styles
import './billing-total.scss';

type TBillingTotalProps = {
  hint: string;
  total: number | string;
};

export const BillingTotal: FC<TBillingTotalProps> = (
  { total, hint }: TBillingTotalProps
) => {

  return (<>
    <div className="billing-total">
      <div className="billing-total--value">
        { total }
      </div>
      <div className="billing-total--hint">
        { hint }
      </div>
    </div>
  </>);
}
